import React, { FC } from 'react';
import { usePermitRequestContext } from '../../../../../contexts/PermitRequestContext';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import InputGroup from '../../../../../components/form/InputGroup';
import addRequestPageLang from '../../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../../hooks/useTags';


const RentingApartmentFiles = () => {

    const { Formik, handleChangeFile } = usePermitRequestContext();
    const { errors, values, touched, handleBlur, setFieldValue } = Formik;

    const generateTag = useTags();

    const isRentAppTitle = generateTag(addRequestPageLang, 'form.files-section.is-rent-app-title');
    const yesLabel = generateTag(addRequestPageLang, 'form.files-section.yesLabel');
    const noLabel = generateTag(addRequestPageLang, 'form.files-section.noLabel');
    const rentContractLabel = generateTag(addRequestPageLang, 'form.files-section.rent-contract-label');
    const propertyTaxBillLabel = generateTag(addRequestPageLang, 'form.files-section.property-tax-bill-label');

    return (
        <div className='row'>
            <div className='col-12'>
                <RadioBtnsContainer label={isRentAppTitle}>

                    <RadioOutlineBtn
                        isChecked={values.extraFiles.isRentApp === 0}
                        label={noLabel}
                        value={0}
                        onClick={handleClick}
                        id="isRentAppNo"
                        name='isRentApp'
                    />

                    <RadioOutlineBtn
                        isChecked={values.extraFiles.isRentApp === 1}
                        label={yesLabel}
                        value={1}
                        onClick={handleClick}
                        id="isRentAppYes"
                        name='isRentApp'
                    />
                </RadioBtnsContainer>
            </div>

            {values.extraFiles.isRentApp === 1 ? (
                <>
                    <div className='col-md-6 col-lg-4'>
                        <InputGroup
                            type={'file'}
                            name={'extraFiles.extraFile4'}
                            label={rentContractLabel}
                            handleBlur={handleBlur}
                            handleChange={(event) => {
                                handleChangeFile('extraFiles.extraFile4', 'extraFile4', event.currentTarget.files[0]);
                            }}
                            isRequired={true}
                            //@ts-ignore
                            errorMsg={(errors.extraFile4 && touched.extraFile4) ? errors.extraFile4 : undefined}
                        />
                    </div>
                    <div className='col-md-6 col-lg-4'>
                        <InputGroup
                            type={'file'}
                            name={'extraFiles.extraFile5'}
                            label={propertyTaxBillLabel}
                            handleBlur={handleBlur}
                            handleChange={(event) => {
                                handleChangeFile('extraFiles.extraFile5', 'extraFile5', event.currentTarget.files[0]);
                            }}
                            isRequired={true}
                            //@ts-ignore
                            errorMsg={(errors.extraFile5 && touched.extraFile5) ? errors.extraFile5 : undefined}
                        />
                    </div>
                </>
            ) : ''}
        </div>
    );

    function handleClick(e: React.MouseEvent<HTMLInputElement>) {
        setFieldValue('extraFiles.isRentApp', Number(e.currentTarget.value));
    }
};

export default RentingApartmentFiles;